/**
 * Get the dimensions of an element
 * @param {string} element - The element to get the dimensions of
 * @returns {DOMRect} - The bounding client rect of the element
 */
function getElementDimensions(element) {

  const elementDom = document.querySelector(element);
  return elementDom.getBoundingClientRect();
}

class HeaderElement extends HTMLElement {
  #lastScrollPosition = window.scrollY;

  connectedCallback() {
    this.#getHeaderHeight();
    this.#handleScroll();
    this.#updateHeaderTop();

    window.addEventListener('resize', this.#getHeaderHeight, { passive: true });
    window.addEventListener('scroll', this.#handleScroll, { passive: true });
  }

  /**
   * Set header height in global scope and CSS var
   */
  #getHeaderHeight = () => {
    const headerHeight = getElementDimensions('header-element').height;
    window.HEADER_HEIGHT = headerHeight;
    document.documentElement.style.setProperty('--header-height', `${headerHeight}px`);
  };

  /**
   * Set header top in global scope and CSS var
   */
  #updateHeaderTop = (top = 0) => {
    const headerTop = `${top}px`;
    document.documentElement.style.setProperty('--header-top', headerTop);
  };

  /**
   * Handle scroll event
   */
  #handleScroll = () => {
    const currentScrollPosition = window.scrollY;

    if (currentScrollPosition <= window.HEADER_HEIGHT) {
      this.#updateHeaderTop();
      this.#lastScrollPosition = currentScrollPosition;
      return;
    }

    currentScrollPosition > this.#lastScrollPosition
      ? this.#updateHeaderTop(window.HEADER_HEIGHT)
      : this.#updateHeaderTop();

    this.#lastScrollPosition = currentScrollPosition;
  };
}

customElements.define('header-element', HeaderElement);
